export default __webpack_public_path__ + "static/media/mistakes_bg.c4ccd7a8.png";